module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "dash-heading"
  }, [_c('i', {
    staticClass: "fa fa-sort-numeric-up"
  }), _vm._v(" Ways: "), _c('small', [_vm._v("Overall Share Ratio: "), _c('b', [_vm._v(_vm._s(this.formatNumber(_vm.stats.sharingRatio)) + "%")])])]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 42
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('table', {
    staticClass: "el-table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Sharing Ways")]), _vm._v(" "), _vm._l((_vm.sharing), function(s) {
    return _c('th', [_vm._v("#" + _vm._s(s.ways) + " way")])
  }), _vm._v(" "), _c('th', [_vm._v("Total")])], 2)]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Sites #")]), _vm._v(" "), _vm._l((_vm.sharing), function(s) {
    return _c('td', [_vm._v(_vm._s(_vm.formatInteger(s.sites)))])
  }), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.formatInteger(this.sitesTotal)))])])], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Sharers #")]), _vm._v(" "), _vm._l((_vm.sharing), function(s) {
    return _c('td', [_vm._v(_vm._s(s.sharers))])
  }), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.formatInteger(this.totalSharers)))])])], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Percent")]), _vm._v(" "), _vm._l((_vm.sharing), function(s) {
    return _c('td', [_vm._v(_vm._s(_vm.formatNumber(s.percent, 1)) + "%")])
  }), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(this.formatNumber(_vm.stats.sharingRatio)) + "%")])])], 2)])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 24,
      "lg": 12
    }
  }, [_c('div', {
    staticClass: "dash-heading"
  }, [_vm._v("Sharers")]), _vm._v(" "), _c('sharer-report')], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 23,
      "md": 23,
      "lg": 11,
      "offset": 1
    }
  }, [_c('div', {
    staticClass: "dash-heading"
  }, [_vm._v("Sharer Ways")]), _vm._v(" "), _c('sharer-ways-report')], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 24,
      "lg": 24
    }
  }, [_c('div', {
    staticClass: "dash-heading"
  }, [_vm._v("Sites Ways")]), _vm._v(" "), _c('sites-ways-table')], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7996ee6b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/sharers/WaysReport.vue
// module id = 1650
// module chunks = 0